import React, { useState, useEffect } from 'react';
import './ClosureBanner.css';

function ClosureBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkDateRange = () => {
      const today = new Date();
      const startDate = new Date('2026-01-09');
      const endDate = new Date('2026-01-21');

      // Show banner from Jan 9 - Jan 20 (will be removed on Jan 21)
      if (today >= startDate && today < endDate) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    checkDateRange();
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="closure-banner">
      <div className="closure-banner-content">
        <p>Office will be closed from January 10 - 20th</p>
      </div>
    </div>
  );
}

export default ClosureBanner;
